var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7811 17.4687L12.9869 3.96875C12.7704 3.59375 12.2291 3.59375 12.0126 3.96875L4.21837 17.4687C4.00186 17.8438 4.27249 18.3125 4.70551 18.3125L20.294 18.3125C20.727 18.3125 20.9976 17.8438 20.7811 17.4687ZM14.4483 3.125C13.5823 1.625 11.4172 1.625 10.5512 3.125L2.75695 16.625C1.89092 18.125 2.97345 20 4.70551 20L20.294 20C22.026 20 23.1085 18.125 22.2425 16.625L14.4483 3.125Z",
    fill: "#FFB200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 17.209C12.034 17.209 11.6563 16.8312 11.6563 16.3652L11.6563 15.846C11.6563 15.38 12.034 15.0023 12.5 15.0023C12.966 15.0023 13.3438 15.38 13.3438 15.846L13.3438 16.3652C13.3438 16.8312 12.966 17.209 12.5 17.209Z",
    fill: "#FFB200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 14.0937C12.034 14.0937 11.6563 13.716 11.6563 13.25L11.6563 9.09615C11.6563 8.63016 12.034 8.2524 12.5 8.2524C12.966 8.2524 13.3438 8.63016 13.3438 9.09615L13.3438 13.25C13.3438 13.716 12.966 14.0937 12.5 14.0937Z",
    fill: "#FFB200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.fd390c402e5ca76949a5ae2ebc4e186e.svg";
export { ForwardRef as ReactComponent };